import type { CableTool } from '#shared/tools'

/*
  Ключи словаря «Утилит» — целиком, а не склейкой `tools.${…}`: проверка
  словаря видит только полные ключи в кавычках, и склеенные числились бы
  мёртвыми, пока их кто-нибудь не удалил.
*/

export type AnyTool = CableTool | 'gamepad' | 'shutter'

export const TOOL_NAME_KEY: Record<AnyTool, string> = {
  iphone: 'tools.name.iphone',
  android: 'tools.name.android',
  camera: 'tools.name.camera',
  disk: 'tools.name.disk',
  gamepad: 'tools.name.gamepad',
  shutter: 'tools.name.shutter',
}

export const TOOL_ABOUT_KEY: Record<AnyTool, string> = {
  iphone: 'tools.about.iphone',
  android: 'tools.about.android',
  camera: 'tools.about.camera',
  disk: 'tools.about.disk',
  gamepad: 'tools.about.gamepad',
  shutter: 'tools.about.shutter',
}

export const TOOL_CONNECT_KEY: Record<CableTool, string> = {
  iphone: 'tools.connect.iphone',
  android: 'tools.connect.android',
  camera: 'tools.connect.camera',
  disk: 'tools.connect.disk',
}

/** Шаги доверия словами: у телефонов «Доверять» или «Разрешить отладку», у камеры и диска их нет */
export const TOOL_TRUST_KEYS: Partial<Record<CableTool, string[]>> = {
  iphone: ['tools.trust.iphone.a', 'tools.trust.iphone.b', 'tools.trust.iphone.c'],
  android: ['tools.trust.android.a', 'tools.trust.android.b', 'tools.trust.android.c'],
}

export const BRIDGE_FAILURE_KEY = {
  absent: 'tools.absent',
  denied: 'tools.denied',
  unreachable: 'tools.unreachable',
} as const

export const TOOL_FIELD_KEY: Record<string, string> = {
  storageGb: 'tools.field.storageGb',
  batteryHealth: 'tools.field.batteryHealth',
  batteryCycles: 'tools.field.batteryCycles',
  batteryLevel: 'tools.field.batteryLevel',
  ios: 'tools.field.ios',
  modelNumber: 'tools.field.modelNumber',
  android: 'tools.field.android',
  shutterCount: 'tools.field.shutterCount',
  type: 'tools.field.type',
  sizeGb: 'tools.field.sizeGb',
  powerOnHours: 'tools.field.powerOnHours',
  temperature: 'tools.field.temperature',
  wearPercent: 'tools.field.wearPercent',
  smart: 'tools.field.smart',
}